import React, { useEffect, useRef, useState } from 'react';
import { useSize } from 'ahooks-v2';
import type { Dispatch} from 'umi';
import { connect, useIntl } from 'umi';

import InfiniteScroll from 'react-infinite-scroll-component';
import type { InquiryState } from '@/models/inquiry';
import InquiryAvatar from '../InquiryAvatar';
import InquiryMessage from '../InquiryMessage';
import styles from './index.less';
interface InquiryRecordListProps {
  inquiry: InquiryState;
  dispatch: Dispatch;
};



let scrollTop=0;
let preScrollHeight=0;
const InquiryRecordList: React.FC<InquiryRecordListProps> = ({
  inquiry,
  dispatch
}) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.Inquiry.InquiryRecordList', intl.formatMessage);

  const scrollRef = useRef<HTMLDivElement>(null);
  const sizeRef = useRef<HTMLDivElement>(null);
  const size = useSize(sizeRef);
  const [hasMore,setHasMore]=useState(true);
  const [list, setList] = useState<number[]>(new Array(10).fill(10));
  useEffect(()=>{
    scrollTop=0;
  },[]);


  useEffect(() => {
    if (inquiry.inquiryHistory.length) {
      const [lastMsg] = inquiry.inquiryHistory.slice(-1);
      console.log('最后一条',lastMsg);
      if (lastMsg.isNewMsg) {
        scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight, behavior: 'smooth' });
      }else {
        scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight - preScrollHeight});
      }
    }
    setHasMore(inquiry.inquiryHistory.length%30===0);
  }, [inquiry.inquiryHistory.length]);
  const fetchData=(e)=>{

    if (scrollTop>e.target.scrollTop && e.target.scrollTop <20 && hasMore) {
      preScrollHeight=e.target.scrollHeight;
      dispatch({
        type:'inquiry/getInquiryHistory',
        payload:{isLoadMore:true}
      });
    }
    scrollTop=e.target.scrollTop;
  };

  return (
    <div id="scrollableDiv" ref={scrollRef}  className={styles.recordListWrap}>
      <InfiniteScroll
        scrollableTarget="scrollableDiv"
        // next={fetchData}
        hasMore={false}
        onScroll={fetchData}
        dataLength={inquiry.inquiryHistory.length}
      >
        {
          inquiry.inquiryHistory.map((item, index) => (
            <div
              key={item.id}
              className={`${styles.messageRow} ${item.eid === inquiry.imEndpoint?.eid ? styles.fromMe : ''}`}
            >
              <div className={styles.messageItem}>
                <InquiryAvatar
                  text={item.eid === inquiry.imEndpoint?.eid ? '我' : inquiry.currentInquiry?.familyInfo?.name}
                  className={styles.avatar}
                />
                <div className={styles.messageContent}>
                  <InquiryMessage imMessage={item}/>
                </div>
              </div>
            </div>
          ))
        }
      </InfiniteScroll>
    </div>

  );
};

const mapToProps = ({ inquiry }: { inquiry: InquiryState }) => {
  return {
    inquiry
  };
};

export default connect(mapToProps)(InquiryRecordList);
